/**
 * 리더보드 제출 Port — 플랫폼 리더보드 백엔드(Android=GPGS / iOS=Game Center)의 추상화.
 * 패키지는 이 인터페이스만 정의하고 플랫폼 SDK를 직접 모른다(DIP). 구현(어댑터)은 호출 프로젝트가
 * 플랫폼별로 주입한다 — Android는 GPGS LeaderboardsClient, iOS는 GameKit GKLeaderboard.
 */
export interface LeaderboardClient {
  /** 이 플랫폼/환경에서 리더보드 제출이 가능한가(미로그인/웹이면 false). */
  isAvailable(): boolean;
  /** 점수 제출 — 백엔드가 기존 최고점과 비교해 갱신. 실패는 graceful(어댑터가 흡수). */
  submitScore(leaderboardId: string, score: number): Promise<void>;
}

/** 리더보드 미지원(웹/비-네이티브) 무동작 클라이언트. */
export class NoopLeaderboardClient implements LeaderboardClient {
  isAvailable(): boolean {
    return false;
  }
  async submitScore(_leaderboardId: string, _score: number): Promise<void> {
    /* no-op */
  }
}
